module.exports = __webpack_public_path__ + "img/bg_theme00012.e3abb0a1.jpg";